module.exports = __webpack_public_path__ + "static/6-d7410118a00212864fd3246e042b210d.jpg";